import React, { useState, useEffect } from "react"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import DataTable from "aldoo-ra/DataTable"
import { VisitorsCRUD, GetVisitorsStats } from "./api"

function StatCard({ label, value }) {
  return (
    <div className="bg-admin_paper border border-admin_bordered rounded-lg p-4">
      <p className="text-xs text-admin_text_secondary mb-1">{label}</p>
      <p className="text-xl font-semibold text-admin_text">{value ?? "—"}</p>
    </div>
  )
}

const TIER_BADGE = {
  high_value:   "bg-admin_warning/15 text-admin_warning",
  medium_value: "bg-admin_info_bg text-admin_info",
  low_value:    "bg-admin_neutral_1 text-admin_text_secondary",
  churning:     "bg-admin_warning/20 text-admin_warning",
  anonymous:    "bg-admin_neutral_1/50 text-admin_text_secondary/70"
}

export default function VisitorBrowser() {
  const [summary, setSummary] = useState(null)
  const [refreshKey, setRefreshKey] = useState(0)

  useEffect(() => {
    GetVisitorsStats().then((res) => {
      if (res.result) setSummary(res.summary)
    })
  }, [refreshKey])

  const columns = [
    {
      id: "visitorId",
      header: "Visitor ID",
      headerClassName: "w-[22%]",
      render: (v) => <span className="text-xs font-mono text-admin_text">{v?.slice(0, 20)}…</span>
    },
    {
      id: "tier",
      header: "Tier",
      headerClassName: "w-[14%]",
      render: (v) => <span className={`text-xs px-2 py-0.5 rounded-full ${TIER_BADGE[v] || ""}`}>{v || "—"}</span>
    },
    {
      id: "chatCount",
      header: "Chats",
      headerClassName: "w-[10%]",
      render: (v) => <span className="text-xs text-admin_text">{v ?? 0}</span>
    },
    {
      id: "visitCount",
      header: "Visits",
      headerClassName: "w-[10%]",
      render: (v) => <span className="text-xs text-admin_text">{v ?? 0}</span>
    },
    {
      id: "ltv",
      header: "LTV",
      headerClassName: "w-[14%]",
      render: (v) => (
        <span className="text-xs text-admin_text">
          {Array.isArray(v) && v.length > 0 ? v.map((l) => `${l.amount} ${l.currency}`).join(", ") : "—"}
        </span>
      )
    },
    {
      id: "email",
      header: "Email",
      headerClassName: "w-[18%]",
      render: (v) => <span className="text-xs text-admin_text">{v || "—"}</span>
    },
    {
      id: "lastSeenAt",
      header: "Last Seen",
      headerClassName: "w-[12%]",
      render: (v) => <span className="text-xs text-admin_text_secondary">{v ? new Date(v).toLocaleDateString() : "—"}</span>
    }
  ]

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-4">
        <Typography variant="h2">Visitors</Typography>
        <Button variant="secondary" size="sm" onClick={() => setRefreshKey((k) => k + 1)}>Refresh</Button>
      </div>

      {summary && (
        <div className="grid grid-cols-4 gap-4 mb-6">
          <StatCard label="Total Visitors" value={summary.totalVisitors?.toLocaleString()} />
          <StatCard label="Identified" value={summary.identified?.toLocaleString()} />
          <StatCard label="Total Chats" value={summary.totalChats?.toLocaleString()} />
          <StatCard label="Total Visits" value={summary.totalVisits?.toLocaleString()} />
        </div>
      )}

      <DataTable
        refreshKey={refreshKey}
        renders={columns}
        apiMethod={VisitorsCRUD.Get}
        requestFields={{}}
      />
    </div>
  )
}
